module.exports = __webpack_public_path__ + "static/media/pre-dorset_text_03.c2f6dc7a.jpg";